import React, { FocusEvent } from 'react'
import { useFormContext } from 'react-hook-form'
import { mixinInputForm } from 'spa/member/styles/mixin'
import styled from 'styled-components'

export type Props = {
  name: string;
} & React.InputHTMLAttributes<HTMLInputElement>

const StyledInputTag = styled.input<{ disabled?: boolean }>`
  ${mixinInputForm}
  height: 3rem;
  ${(props) => (props.disabled && `background-color: ${props.theme.members.colors.silver._30};`)}
`

export const StyledInput: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()
  return (
    <div>
      <StyledInputTag {...props} {...register(props.name, { onBlur: (e: FocusEvent<HTMLInputElement, Element>): void => props.onBlur && props.onBlur(e) })} />
    </div>
  )
}
